import { useQuery } from '@tanstack/react-query'
import { getEventById, getEventsByShowId } from 'api/event'

export const useEventByIdUser = (id: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event', id],
        queryFn: () => getEventById(id),
        enabled: !!id,
    })

    return {
        data,
        isLoading,
        error,
    }
}

export const useEventsByShowIds = (showIds: string[]) => {
    const {
        data: eventsByShowId,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['events', showIds],
        queryFn: async () => {
            const eventsPromises = showIds.map((showId) => getEventsByShowId(showId))
            const allEvents = await Promise.all(eventsPromises)
            return allEvents.flat()
        },
        enabled: showIds.length > 0,
    })

    return { eventsByShowId, isLoading, error }
}
